<script setup lang="ts">
import { useI18n } from '@/i18n'
const { t } = useI18n()
</script>

<template>
  <div class="unsupported">
    <div class="box">
      <h1>{{ t('unsupported.title') }}</h1>
      <p>{{ t('unsupported.body') }}</p>
    </div>
  </div>
</template>

<style scoped>
.unsupported {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.box {
  max-width: 520px;
  background: var(--bg-1);
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-lg);
  padding: 24px;
}
h1 {
  font-size: 18px;
  margin: 0 0 12px;
}
</style>
